<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="MS910 Series">
     MS910 Series
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety" title="Safety information">
     Safety information
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="Conventions">
      Conventions
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-cautions-water-topic.html#d0e43" title="Product statements">
      Product statements
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learning-about-printer-chapter.html#learning-about-printer-chapter" title="Learning about the printer">
     Learning about the printer
    </a>
   </p>
   <div id="divd0e223">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer" title="Finding information about the printer">
      Finding information about the printer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="connecting-the-printer-to-outlet-topic.html#connecting-the-printer-to-outlet" title="Connecting the printer to an outlet">
      Connecting the printer to an outlet
     </a>
    </p>
    <p class="toc-2-style">
     <a href="selecting-location-printer-m-topic.html#selecting-location-printer-m" title="Selecting a location for the printer">
      Selecting a location for the printer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-configurations-topic.html#printer-configurations" title="Printer configurations">
      Printer configurations
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="understanding-home-screen-chapter.html#understanding-home-screen-chapter" title="Understanding the printer control panel">
     Understanding the printer control panel
    </a>
   </p>
   <div id="divd0e586">
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel" title="Using the control panel">
      Using the control panel
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-colors-sleep-button-indicator-lights-h-topic.html#understanding-colors-sleep-button-indicator-lights-h" title="Understanding the colors of the Sleep button and indicator lights">
      Understanding the colors of the Sleep button and indicator lights
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-home-screen-topic.html#understanding-home-screen" title="Understanding the home screen">
      Understanding the home screen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-touch-screen-buttons-topic.html#using-touch-screen-buttons" title="Using the touch-screen buttons">
      Using the touch-screen buttons
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter" title="Setting up and using the home screen applications">
     Setting up and using the home screen applications
    </a>
   </p>
   <div id="divd0e1051">
    <p class="toc-2-style">
     <a href="finding-ip-address-of-printer-topic.html#finding-ip-address-of-printer" title="Finding the IP address of the printer">
      Finding the IP address of the printer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="finding-ip-address-of-computer-topic.html#finding-ip-address-of-computer" title="Finding the IP address of the computer">
      Finding the IP address of the computer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="accessing-embedded-web-server-topic.html#accessing-embedded-web-server" title="Accessing the Embedded Web Server">
      Accessing the Embedded Web Server
     </a>
    </p>
    <p class="toc-2-style">
     <a href="activating-home-screen-apps-group.html#activating-home-screen-apps-title" title="Activating the home screen applications">
      Activating the home screen applications
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-remote-operator-panel-topic.html#setting-up-remote-operator-panel" title="Setting up Remote Operator Panel">
      Setting up Remote Operator Panel
     </a>
    </p>
    <p class="toc-2-style">
     <a href="exporting-importing-configuration-using-ews-winners-circle-topic.html#exporting-importing-configuration-using-ews-winners-circle" title="Exporting and importing a configuration">
      Exporting and importing a configuration
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="installing-options-chapter.html#installing-options-chapter" title="Additional printer setup">
     Additional printer setup
    </a>
   </p>
   <div id="divd0e1372">
    <p class="toc-2-style">
     <a href="internal-options.html#internal-options" title="Installing internal options">
      Installing internal options
     </a>
    </p>
    <p class="toc-2-style">
     <a href="order-installation-topic.html#d0e1706" title="Installing hardware options">
      Installing hardware options
     </a>
    </p>
    <p class="toc-2-style">
     <a href="attaching-cables-topic.html#attaching-cables" title="Attaching cables">
      Attaching cables
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e1936" title="Setting up the printer software">
      Setting up the printer software
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preparing-set-up-printer-ethernet-network-topic.html#d0e2006" title="Networking">
      Networking
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-h2-topic.html#d0e2371" title="Verifying printer setup">
      Verifying printer setup
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="loading-paper-and-specialty-media-chapter.html#loading-paper-and-specialty-media-chapter" title="Loading paper and specialty media">
     Loading paper and specialty media
    </a>
   </p>
   <div id="divd0e2417">
    <p class="toc-2-style">
     <a href="setting-paper-size-and-type-topic.html#setting-paper-size-and-type" title="Setting the paper size and type">
      Setting the paper size and type
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-universal-paper-settings-topic.html#configuring-universal-paper-settings" title="Configuring Universal paper settings">
      Configuring Universal paper settings
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-trays-topic.html#loading-trays" title="Loading trays">
      Loading trays
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-multipurpose-feeder-h-topic.html#loading-multipurpose-feeder-h" title="Loading the multipurpose feeder">
      Loading the multipurpose feeder
     </a>
    </p>
    <p class="toc-2-style">
     <a href="linking-and-unlinking-trays-h2-topic.html#d0e2597" title="Linking and unlinking trays">
      Linking and unlinking trays
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="paper-and-specialty-media-guide-chapter.html#paper-and-specialty-media-guide-chapter" title="Paper and specialty media guide">
     Paper and specialty media guide
    </a>
   </p>
   <div id="divd0e2716">
    <p class="toc-2-style">
     <a href="using-specialty-media.html#d0e2727" title="Using specialty media">
      Using specialty media
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-guidelines-group-title.html#paper-guidelines-group-title" title="Paper guidelines">
      Paper guidelines
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-sizes-supported-printer-topic.html#d0e3129" title="Supported paper sizes, types, and weights">
      Supported paper sizes, types, and weights
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printing-chapter.html#printing-chapter" title="Printing">
     Printing
    </a>
   </p>
   <div id="divd0e4881">
    <p class="toc-2-style">
     <a href="printing-forms-topic.html#d0e4884" title="Printing forms and a document">
      Printing forms and a document
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-flash-drive-h2-topic.html#d0e4958" title="Printing from a flash drive or mobile device">
      Printing from a flash drive or mobile device
     </a>
    </p>
    <p class="toc-2-style">
     <a href="holding-confidential-other-jobs.html#holding-confidential-other-jobs" title="Printing confidential and other held jobs">
      Printing confidential and other held jobs
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-h2-topic.html#d0e5257" title="Printing information pages">
      Printing information pages
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-from-printer-control-panel-h2-topic.html#d0e5302" title="Canceling a print job">
      Canceling a print job
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="understanding-printer-menus-chapter.html#understanding-printer-menus-chapter" title="Understanding the printer menus">
     Understanding the printer menus
    </a>
   </p>
   <div id="divd0e5346">
    <p class="toc-2-style">
     <a href="menus-list-topic.html#menus-list" title="Menus list">
      Menus list
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-menu-group.html#paper-menu-group" title="Paper menu">
      Paper menu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="reports-group.html#reports-group" title="Reports menu">
      Reports menu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-ports-group.html#network-ports-group" title="Network/Ports menu">
      Network/Ports menu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="security-menus-group.html#d0e8134" title="Security menu">
      Security menu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="settings-group.html#settings-group" title="Settings menu">
      Settings menu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="help-menu-topic.html#help-menu" title="Help menu">
      Help menu
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="conserving-printer-energy-materials.html#conserving-printer-energy-materials" title="Saving money and the environment">
     Saving money and the environment
    </a>
   </p>
   <div id="divd0e11047">
    <p class="toc-2-style">
     <a href="conserving-printer-energy-materials.html#d0e11065" title="Saving paper and toner">
      Saving paper and toner
     </a>
    </p>
    <p class="toc-2-style">
     <a href="conserving-printer-energy-materials.html#d0e11126" title="Saving energy">
      Saving energy
     </a>
    </p>
    <p class="toc-2-style">
     <a href="conserving-printer-energy-materials.html#d0e11319" title="Recycling">
      Recycling
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="configuring-printer-hard-disk-security-settings-chapter.html#configuring-printer-hard-disk-security-settings-chapter" title="Securing the printer">
     Securing the printer
    </a>
   </p>
   <div id="divd0e11387">
    <p class="toc-2-style">
     <a href="using-security-lock-feature-m-topic.html#using-security-lock-feature-m" title="Using the security lock feature">
      Using the security lock feature
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-h-topic.html#statement-of-volatility-h" title="Statement of Volatility">
      Statement of Volatility
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-volatile-memory-h-topic.html#erasing-volatile-memory-h" title="Erasing volatile memory">
      Erasing volatile memory
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-non-volatile-memory-h-topic.html#erasing-non-volatile-memory-h" title="Erasing non-volatile memory">
      Erasing non-volatile memory
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-hard-disk-memory-h1-topic.html#erasing-printer-hard-disk-memory-h1" title="Erasing printer hard disk memory">
      Erasing printer hard disk memory
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-printer-hard-disk-encryption-topic.html#configuring-printer-hard-disk-encryption" title="Configuring printer hard disk encryption">
      Configuring printer hard disk encryption
     </a>
    </p>
    <p class="toc-2-style">
     <a href="finding-printer-security-information-b-topic.html#finding-printer-security-information-b" title="Finding the printer security information">
      Finding the printer security information
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter" title="Maintaining the printer">
     Maintaining the printer
    </a>
   </p>
   <div id="divd0e11625">
    <p class="toc-2-style">
     <a href="updating-firmware-using-control-panel-topic.html#d0e11630" title="Updating firmware">
      Updating firmware
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#d0e11715" title="Cleaning printer parts">
      Cleaning printer parts
     </a>
    </p>
    <p class="toc-2-style">
     <a href="checking-status-of-parts-and-supplies-on-printer-control-panel-topic.html#d0e11815" title="Checking the status of parts and supplies">
      Checking the status of parts and supplies
     </a>
    </p>
    <p class="toc-2-style">
     <a href="estimated-number-remaining-pages-topic.html#estimated-number-remaining-pages" title="Estimated&nbsp;number of&nbsp;remaining&nbsp;pages">
      Estimated&nbsp;number of&nbsp;remaining&nbsp;pages
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-supplies.html#ordering-supplies-group" title="Ordering supplies">
      Ordering supplies
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-maintenance-kit-topic.html#ordering-maintenance-kit" title="Ordering a 300K maintenance kit">
      Ordering a 300K maintenance kit
     </a>
    </p>
    <p class="toc-2-style">
     <a href="storing-supplies-topic.html#d0e12067" title="Storing parts and supplies">
      Storing parts and supplies
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-supplies.html#replacing-supplies-group" title="Replacing supplies">
      Replacing supplies
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-exhaust-ozone-filters-topic.html#d0e12321" title="Replacing the 300K maintenance kit">
      Replacing the 300K maintenance kit
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-the-printer.html#moving-the-printer" title="Moving the printer">
      Moving the printer
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="administrative-support-chapter.html#administrative-support-chapter" title="Managing the printer">
     Managing the printer
    </a>
   </p>
   <div id="divd0e12632">
    <p class="toc-2-style">
     <a href="checking-virtual-display-h-topic.html#checking-virtual-display-h" title="Checking the virtual display">
      Checking the virtual display
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-reports-topic.html#viewing-reports" title="Viewing reports">
      Viewing reports
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-printer-settings-to-other-printers-topic.html#copying-printer-settings-to-other-printers" title="Copying printer settings to other printers">
      Copying printer settings to other printers
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-supply-notifications-h2-topic.html#configuring-supply-notifications-h2" title="Configuring supply notifications from the Embedded Web Server">
      Configuring supply notifications from the Embedded Web Server
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-h-topic.html#restoring-factory-default-settings-h" title="Restoring factory default settings">
      Restoring factory default settings
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="clearing-jams-chapter.html#clearing-jams-chapter" title="Clearing jams">
     Clearing jams
    </a>
   </p>
   <div id="divd0e12829">
    <p class="toc-2-style">
     <a href="avoiding-jams-topic.html#avoiding-jams" title="Avoiding jams">
      Avoiding jams
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-jam-messages-topic.html#understanding-jam-messages" title="Understanding jam messages and locations">
      Understanding jam messages and locations
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-page-jam-clear-manual-feeder-topic.html#message-page-jam-clear-manual-feeder" title="[x]-page jam, clear jammed paper from multipurpose feeder.&nbsp;[200.xx]">
      [x]-page jam, clear jammed paper from multipurpose feeder.&nbsp;[200.xx]
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-open-door-c-clear-all-jammed-media-topic.html#paper-jam-open-door-c-clear-all-jammed-media" title="[x]-page jam, open door C and clear all jammed paper.&nbsp;[2yy.xx]">
      [x]-page jam, open door C and clear all jammed paper.&nbsp;[2yy.xx]
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-slide-tray-open-door-c-topic.html#paper-jam-slide-tray-open-door-c" title="[x]-page jam, slide the 3000-sheet tray and open door C.&nbsp;[2yy.xx]">
      [x]-page jam, slide the 3000-sheet tray and open door C.&nbsp;[2yy.xx]
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-open-door-d-clear-all-jammed-media-topic.html#paper-jam-open-door-d-clear-all-jammed-media" title="[x]-page jam, open door D and clear all jammed paper.&nbsp;[24y.xx]">
      [x]-page jam, open door D and clear all jammed paper.&nbsp;[24y.xx]
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-slide-tray-open-door-d-topic.html#paper-jam-slide-tray-open-door-d" title="[x]-page jam, slide the 3000-sheet tray and open door D.&nbsp;[24y.xx]">
      [x]-page jam, slide the 3000-sheet tray and open door D.&nbsp;[24y.xx]
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-page-jam-detach-tray-open-door-f-topic.html#message-page-jam-detach-tray-open-door-f" title="[x]-page jam, slide the 3000-sheet tray and open door F.&nbsp;[24y.xx]">
      [x]-page jam, slide the 3000-sheet tray and open door F.&nbsp;[24y.xx]
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-page-jam-open-doors-g-h-j-clear-jammed-paper-topic.html#message-page-jam-open-doors-g-h-j-clear-jammed-paper" title="[x]-page jam, open doors G, H, and J and clear jammed paper. Leave paper in bin.&nbsp;[4yy.xx]">
      [x]-page jam, open doors G, H, and J and clear jammed paper. Leave paper in bin.&nbsp;[4yy.xx]
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-page-jam-press-latch-to-access-area-g-leave-paper-in-bin-topic.html#message-page-jam-press-latch-to-access-area-g-leave-paper-in-bin" title="[x]-page jam, press latch to access area G.&nbsp;Leave paper in bin.&nbsp;[40y.xx]">
      [x]-page jam, press latch to access area G.&nbsp;Leave paper in bin.&nbsp;[40y.xx]
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-page-jam-press-latch-to-access-area-g-clear-jammed-staples-leave-paper-in-bin-topic.html#message-page-jam-press-latch-to-access-area-g-clear-jammed-staples-leave-paper-in-bin" title="[x]-page jam, press latch to access area G and clear jammed staples.&nbsp;Leave paper in bin.&nbsp;[402.93]">
      [x]-page jam, press latch to access area G and clear jammed staples.&nbsp;Leave paper in bin.&nbsp;[402.93]
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-paper-jam-open-door-h-rotate-knob-h6-clockwise-leave-paper-in-bin-topic.html#message-paper-jam-open-door-h-rotate-knob-h6-clockwise-leave-paper-in-bin" title="[x]-page jam, open door H and rotate knob H6 clockwise. Leave paper in bin.&nbsp;[426.xx&ndash;428.xx]">
      [x]-page jam, open door H and rotate knob H6 clockwise. Leave paper in bin.&nbsp;[426.xx&ndash;428.xx]
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter" title="Troubleshooting">
     Troubleshooting
    </a>
   </p>
   <div id="divd0e13494">
    <p class="toc-2-style">
     <a href="list-status-error-messages-group.html#list-status-error-messages-group" title="Understanding the printer messages">
      Understanding the printer messages
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-printer-not-responding-topic.html#d0e14984" title="Solving printer problems">
      Solving printer problems
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-confidential-held-jobs-do-not-print-topic.html#d0e15704" title="Solving print problems">
      Solving print problems
     </a>
    </p>
    <p class="toc-2-style">
     <a href="application-error-has-occurred-topic.html#d0e18293" title="Solving home screen application problems">
      Solving home screen application problems
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-embedded-web-server-does-not-open-topic.html#trb-embedded-web-server-does-not-open" title="Embedded Web Server does not open">
      Embedded Web Server does not open
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support" title="Contacting customer support">
      Contacting customer support
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices" title="Notices">
     Notices
    </a>
   </p>
   <div id="divd0e18510">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e18513" title="Product information">
      Product information
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e18530" title="Edition notice">
      Edition notice
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#us-government-rights" title="GOVERNMENT END USERS">
      GOVERNMENT END USERS
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks" title="Trademarks">
      Trademarks
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#federal-communications-commission-fcc-compliance-information-statement" title="Federal Communications Commission (FCC) compliance information statement">
      Federal Communications Commission (FCC) compliance information statement
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices" title="Licensing notices">
      Licensing notices
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels" title="Noise emission levels">
      Noise emission levels
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#weee-directive" title="Waste from Electrical and Electronic Equipment (WEEE) directive">
      Waste from Electrical and Electronic Equipment (WEEE) directive
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#e-waste-notice" title="India E-Waste notice">
      India E-Waste notice
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal" title="Product disposal">
      Product disposal
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice" title="Static sensitivity notice">
      Static sensitivity notice
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star" title="ENERGY STAR">
      ENERGY STAR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information" title="Temperature information">
      Temperature information
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e18837" title="Laser notice">
      Laser notice
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-advisory-label" title="Laser advisory label">
      Laser advisory label
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption" title="Power consumption">
      Power consumption
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e19013" title="Applicability of Regulation (EU) 2019/2015 and (EU) 2019/2020">
      Applicability of Regulation (EU) 2019/2015 and (EU) 2019/2020
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#japanese-vcci-notice" title="Japanese VCCI notice">
      Japanese VCCI notice
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#european-community-ec-directives-conformity" title="European Community (EC) directives conformity">
      European Community (EC) directives conformity
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#radio-interference-notice" title="Radio interference notice">
      Radio interference notice
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#regulatory-notices-for-wireless-products" title="Regulatory notices for wireless products">
      Regulatory notices for wireless products
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#modular-component-notice" title="Modular component notice">
      Modular component notice
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#exposure-to-radio-frequency-radiation" title="Exposure to radio frequency radiation">
      Exposure to radio frequency radiation
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#industry-canada-en" title="Industry Canada (Canada)">
      Industry Canada (Canada)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#notice-to-users-in-the-european-union" title="Notice to users in the European Union">
      Notice to users in the European Union
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#statement-of-limited-warranty" title="STATEMENT OF LIMITED WARRANTY FOR LEXMARK LASER PRINTERS, LEXMARK LED PRINTERS, AND LEXMARK MULTIFUNCTION LASER PRINTERS">
      STATEMENT OF LIMITED WARRANTY FOR LEXMARK LASER PRINTERS, LEXMARK LED PRINTERS, AND LEXMARK MULTIFUNCTION LASER PRINTERS
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#patent-acknowledgment" title="Patent acknowledgment">
      Patent acknowledgment
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue